module.exports = __webpack_public_path__ + "img/close_up_mold.61624d1e.jpg";